import hero from '../mocks/hero.json'
import featuredPerson from '../mocks/featured-person.json'
import news from '../mocks/local-news.json'

export default class ApiService {
    static localHostUrl = "http://localhost:2000";
    static baseUrl = process.env.REACT_APP_BASE_URL || "https://api.nrna.org.au";

    static async getLive(requestPath) {
        try {
            const res = await fetch(`${ApiService.baseUrl}/${requestPath}`, { mode: 'cors'});
            return res.json();
        } catch(exception) {
            console.log(`ApiService.get`, exception);
            throw exception;
        }
    }


    static async getStatic(requestPath) {
        try {
            switch(requestPath) {
                case 'hero':
                    return [hero];
                case 'featured-person':
                    return featuredPerson;
                case 'news':
                    return news;
                default:
                    return null;
            }
        } catch(exception) {
            console.log(`ApiService.getStatic`, exception);
            throw exception;
        }
    }


    static get = this.getStatic
}